<template>
	<div role="button" class="selection-button" v-bind="$attrs" v-on="$listeners">
		<slot />
	</div>
</template>

<script>
export default {
	name: 'SelectionButton',
};
</script>

<style scoped lang="scss">
.selection-button {
	background: white;
	height: 36px;
	width: 100%;
	padding: 0 12px;
	border: 1px solid #dfe4ef;
	border-radius: 4px;
	line-height: 36px;
	font-size: 14px;
	font-weight: 400 !important;
	text-align: left;
	cursor: pointer;
	transition: all 0.15s;
	color: var(--primary-color) !important;

	&:hover {
		background: rgba(0, 0, 0, 0.02);
	}
}
</style>
